const calcDNDTime = (time) => {
    const date = new Date();
  
    if (time !== 'EOD') {
      const milliseconds = 60000 * time;
      const dndTime = new Date(date.getTime() + milliseconds);
      return dndTime;
    }
  
    date.setHours(23, 59, 59, 999);
    return new Date(date);
  };
  
  export const dndUntilOptions = {
    dndForever: { selectOptionValue: 'dndForever', text: 'Until I change my status', dateTimeValue: 'dndForever' },
    dndFor30Minutes: { selectOptionValue: 'dndFor30Minutes', text: '30 minutes', dateTimeValue: () => calcDNDTime(30) },
    dndFor1Hour: { selectOptionValue: 'dndFor1Hour', text: '1 hour', dateTimeValue: () => calcDNDTime(60) },
    dndFor6Hours: { selectOptionValue: 'dndFor6Hours', text: '6 hours', dateTimeValue: () => calcDNDTime(360) },
    dndForRestOfDay: { selectOptionValue: 'dndForRestOfDay', text: 'Today', dateTimeValue: () => calcDNDTime('EOD') },
    dndForCustom: { selectOptionValue: 'dndForCustom', text: 'Custom', dateTimeValue: 'dndForCustom' },
  };
